window.groomConfig = {
    "timeRangesByWeekday": {
        "1": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 2
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ],
        "2": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 2
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ],
        "3": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 2
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ],
        "4": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 2
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ],
        "5": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 2
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ],
        "6": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 1
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ],
        "7": [
            {
                "start": "11:45",
                "end": "13:30",
                "capacity": 1
            },
            {
                "start": "16:30",
                "end": "18:30",
                "capacity": 1
            },
            {
                "start": "18:30",
                "end": "19:15",
                "capacity": 1
            }
        ]
    },
    "globalMinTime": "11:45",
    "globalMaxTime": "19:15",
    "currentAppointments": {
        "2026-11-04 18:45": 1,
        "2026-11-04 19:00": 1,
        "2026-11-04 19:15": 1,
        "2026-11-04 19:30": 1,
        "2026-11-04 19:45": 1,
        "2026-11-04 20:00": 1,
        "2026-11-04 20:15": 1,
        "2026-11-04 16:30": 4,
        "2026-11-04 16:45": 4,
        "2026-11-04 17:00": 3,
        "2026-11-04 17:15": 3,
        "2026-11-04 17:30": 3,
        "2026-11-04 17:45": 3,
        "2026-11-04 15:15": 1,
        "2026-11-04 15:30": 1,
        "2026-11-04 15:45": 1,
        "2026-11-04 16:00": 1,
        "2026-11-04 16:15": 1,
        "2026-11-06 11:45": 1,
        "2026-11-06 12:00": 1,
        "2026-11-06 12:15": 1,
        "2026-11-06 12:30": 1,
        "2026-11-06 12:45": 1,
        "2026-11-06 17:15": 1,
        "2026-11-06 17:30": 1,
        "2026-11-06 17:45": 1,
        "2026-11-06 18:00": 1,
        "2026-11-06 18:15": 1,
        "2026-11-07 09:45": 1,
        "2026-11-07 10:00": 1,
        "2026-11-07 10:15": 1,
        "2026-11-07 10:30": 1,
        "2026-11-07 10:45": 1,
        "2026-11-07 11:00": 1,
        "2026-11-07 11:15": 1,
        "2026-11-07 16:30": 1,
        "2026-11-07 16:45": 1,
        "2026-11-07 17:00": 1,
        "2026-11-07 17:15": 1,
        "2026-11-07 17:30": 1,
        "2026-11-07 17:45": 1,
        "2026-11-10 18:30": 2,
        "2026-11-10 18:45": 2,
        "2026-11-10 19:00": 2,
        "2026-11-10 11:45": 1,
        "2026-11-10 12:00": 1,
        "2026-11-10 12:15": 1,
        "2026-11-10 12:30": 1,
        "2026-11-10 12:45": 1,
        "2026-11-11 12:15": 1,
        "2026-11-11 12:30": 1,
        "2026-11-11 12:45": 1,
        "2026-11-11 13:00": 1,
        "2026-11-11 13:15": 1,
        "2026-11-12 16:45": 1,
        "2026-11-12 17:00": 1,
        "2026-11-12 17:15": 1,
        "2026-11-12 17:30": 1,
        "2026-11-12 17:45": 1,
        "2026-11-12 18:00": 1,
        "2026-11-12 18:15": 1,
        "2026-11-13 16:30": 2,
        "2026-11-13 16:45": 2,
        "2026-11-13 17:00": 2,
        "2026-11-13 17:15": 2,
        "2026-11-13 17:30": 2,
        "2026-11-13 17:45": 2,
        "2026-11-13 18:30": 1,
        "2026-11-13 18:45": 1,
        "2026-11-13 19:00": 1,
        "2026-11-14 10:15": 1,
        "2026-11-14 10:30": 1,
        "2026-11-14 10:45": 2,
        "2026-11-14 11:00": 2,
        "2026-11-14 11:15": 2,
        "2026-11-14 11:30": 2,
        "2026-11-14 11:45": 2,
        "2026-11-14 12:00": 1,
        "2026-11-14 12:15": 1,
        "2026-11-20 16:30": 1,
        "2026-11-20 16:45": 1,
        "2026-11-20 17:00": 1,
        "2026-11-20 17:15": 1,
        "2026-11-28 10:45": 1,
        "2026-11-28 11:00": 1,
        "2026-11-28 11:15": 1,
        "2026-11-28 11:30": 1,
        "2026-11-28 11:45": 1,
        "2026-11-28 12:00": 1,
        "2026-11-28 12:15": 1,
        "2026-11-30 17:15": 1,
        "2026-11-30 17:30": 1,
        "2026-11-30 17:45": 1,
        "2026-11-30 18:00": 1,
        "2026-11-30 18:15": 1,
        "2026-12-04 16:30": 1,
        "2026-12-04 16:45": 1,
        "2026-12-04 17:00": 1,
        "2026-12-04 17:15": 1,
        "2026-12-18 16:30": 1,
        "2026-12-18 16:45": 1,
        "2026-12-18 17:00": 1,
        "2026-12-18 17:15": 1,
        "2026-12-19 10:45": 2,
        "2026-12-19 11:00": 2,
        "2026-12-19 11:15": 2,
        "2026-12-19 11:30": 2,
        "2026-12-19 11:45": 2,
        "2026-12-19 12:00": 1,
        "2026-12-19 12:15": 1,
        "2026-12-19 10:15": 1,
        "2026-12-19 10:30": 1,
        "2026-12-29 11:45": 1,
        "2026-12-29 12:00": 1,
        "2026-12-29 12:15": 1,
        "2026-12-29 12:30": 1,
        "2027-01-23 16:30": 1,
        "2027-01-23 16:45": 1,
        "2027-01-23 17:00": 1,
        "2027-01-23 17:15": 1,
        "2027-01-23 17:30": 1,
        "2027-01-23 17:45": 1,
        "2027-01-23 11:45": 1,
        "2027-01-23 12:00": 1,
        "2027-01-23 12:15": 1,
        "2027-01-23 12:30": 1,
        "2027-01-23 12:45": 1,
        "2027-01-29 10:45": 1,
        "2027-01-29 11:00": 1,
        "2027-01-29 11:15": 1,
        "2027-01-29 11:30": 1,
        "2027-01-29 11:45": 1,
        "2027-01-29 12:00": 1,
        "2027-01-29 12:15": 1,
        "2027-02-12 11:45": 1,
        "2027-02-12 12:00": 1,
        "2027-02-12 12:15": 1,
        "2027-02-12 12:30": 1,
        "2027-02-12 12:45": 1,
        "2027-02-12 13:00": 1,
        "2027-02-12 13:15": 1,
        "2027-04-16 18:30": 1,
        "2027-04-16 18:45": 1,
        "2027-04-16 19:00": 1
    },
    "closed_days": [
        "2026-11-08",
        "2026-11-15",
        "2026-11-22",
        "2026-11-29",
        "2026-12-25",
        "2026-12-26",
        "2026-12-27",
        "2027-01-01",
        "2027-01-03",
        "2027-01-06",
        "2027-01-17",
        "2027-01-24",
        "2027-01-31"
    ],
    "full_days": [
        "2026-11-04",
        "2026-11-06",
        "2026-11-07"
    ],
    "full_ranges": {
        "2026-11-04": [
            {
                "start": "18:30",
                "end": "19:15"
            },
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-11-06": [
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-11-07": [
            {
                "start": "11:45",
                "end": "13:30"
            },
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-11-10": [
            {
                "start": "18:30",
                "end": "19:15"
            }
        ],
        "2026-11-12": [
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-11-13": [
            {
                "start": "16:30",
                "end": "18:30"
            },
            {
                "start": "18:30",
                "end": "19:15"
            }
        ],
        "2026-11-14": [
            {
                "start": "11:45",
                "end": "13:30"
            }
        ],
        "2026-11-20": [
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-11-28": [
            {
                "start": "11:45",
                "end": "13:30"
            }
        ],
        "2026-11-30": [
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-12-04": [
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-12-18": [
            {
                "start": "16:30",
                "end": "18:30"
            }
        ],
        "2026-12-19": [
            {
                "start": "11:45",
                "end": "13:30"
            }
        ],
        "2027-01-23": [
            {
                "start": "16:30",
                "end": "18:30"
            },
            {
                "start": "11:45",
                "end": "13:30"
            }
        ],
        "2027-04-16": [
            {
                "start": "18:30",
                "end": "19:15"
            }
        ]
    },
    "slottedSections": [
        "groom",
        "tailoring",
        "cita"
    ]
};
